import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 统一的懒加载组件引用，避免到处重复写
const Home = () => import('./views/Home.vue')
const Search = () => import('./views/Search.vue')
const ContentPage = () => import('./views/ContentPage.vue')
const About = () => import('./views/About.vue')
const Login = () => import('./views/Login.vue')

// 生成同结构栏目的路由，减少重复
const buildSectionRoutes = (base, listTitle, detailTitle) => ([
  {
    path: `/${base}`,
    name: base,
    component: ContentPage,
    meta: { title: listTitle }
  },
  {
    path: `/${base}/:categoryId`,
    name: `${base}-category`,
    component: ContentPage,
    meta: { title: listTitle }
  },
  {
    path: `/${base}/detail/:categoryId/:productId`,
    name: `${base}-detail`,
    component: ContentPage,
    meta: { title: detailTitle }
  }
])

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { title: '基因编辑稳转株/文库筛选/脱靶检测 - 恒毅新生物' }
  },
  {
    path: '/search',
    name: 'search',
    component: Search,
    meta: { title: '搜索 - 恒毅新生物' }
  },
  ...buildSectionRoutes('product', '产品服务 - 恒毅新生物', '恒毅新生物'),
  ...buildSectionRoutes('platform', '技术平台 - 恒毅新生物', '技术平台详情 - 恒毅新生物'),
  ...buildSectionRoutes('news', '新闻中心 - 恒毅新生物', '新闻详情 - 恒毅新生物'),
  {
    path: '/about',
    name: 'about',
    component: About,
    meta: { title: '关于我们 - 恒毅新生物' }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { title: '登录 - 恒毅新生物' }
  },
  // 兜底到首页（也可改为 NotFound 页面）
  { path: '*', redirect: '/' }
]

let kejianrouter = new Router({
  mode: 'history', // 使用history模式，URL更简洁
  scrollBehavior(to, from, savedPosition) {
    // 返回上一个页面时，保留滚动位置；否则回到顶部
    if (savedPosition) return savedPosition
    return { x: 0, y: 0 }
  },
  routes
})

// 判断是否需要登录权限 以及是否登录
kejianrouter.beforeEach((to, from, next) => {
  // 动态更新页面标题
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  } else {
    // 如果没有设置title，使用默认标题
    document.title = '恒毅新生物'
  }
  
  // 判断是否需要登录权限
  if (to.matched.some(res => res.meta.requireAuth)) {
    // 判断是否登录
    if (sessionStorage.getItem('token')) {
      next()
    } else {
      // 没登录则跳转到登录界面
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    }
  } else {
    next()
  }
})

export default kejianrouter